
// import { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { NavLink } from 'react-router-dom';
// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';

// import LogoHeader from '../Assets/Image/Logomain.png';
// import '../Assets/Css/webheader.css';


// function WebHeader() {
//   const [expanded, setExpanded] = useState(false);
//   const handleNavClick = () => setExpanded(false);
//   const [activeLink, setActiveLink] = useState('home');

//   useEffect(() => {
//     const handleScroll = () => {
//       const sections = ['home', 'about', 'technologies', 'contact'];
//       const scrollPos = window.scrollY + 160; // Adjust for fixed header

//       for (let section of sections) {
//         const el = document.getElementById(section);
//         if (el && el.offsetTop <= scrollPos && el.offsetTop + el.offsetHeight > scrollPos) {
//           setActiveLink(section);
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll(); // Set initial
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const isActive = (id) => activeLink === id ? 'active' : '';


//   return (
//     <>
     
     

//       {/* Main Navbar */}

//       <Navbar expand="lg" className="custom-navbar fixed-top" expanded={expanded}>
//         <Container>
//           <Navbar.Brand href="#home">
//             <img src={LogoHeader} alt="Logo" className="navbar-logo" />
//           </Navbar.Brand>
//           <Navbar.Toggle onClick={() => setExpanded(!expanded)} />
//           <Navbar.Collapse>
//             <Nav className="mx-auto">
//               <Nav.Link href="#home" onClick={handleNavClick} className={isActive('home')}>Home</Nav.Link>
//               <Nav.Link href="#about" onClick={handleNavClick} className={isActive('about')}>About Us</Nav.Link>
//               <Nav.Link href="#technologies" onClick={handleNavClick} className={isActive('technologies')}>Technologies</Nav.Link>
           
//               <Nav.Link href="#contact" onClick={handleNavClick} className={isActive('contact')}>Contact Us</Nav.Link>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>

//     </>
//   );
// }

// export default WebHeader;






import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LogoHeader from '../Assets/Image/Logomain.png';
import '../Assets/Css/webheader.css';

function WebHeader() {
  const [activeLink, setActiveLink] = useState('home');
  const [showSidebar, setShowSidebar] = useState(false);

  const handleNavClick = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'technologies', 'contact'];
      const scrollPos = window.scrollY + 160;

      for (let section of sections) {
        const el = document.getElementById(section);
        if (el && el.offsetTop <= scrollPos && el.offsetTop + el.offsetHeight > scrollPos) {
          setActiveLink(section);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (id) => (activeLink === id ? 'active' : '');

  return (
    <>
      {/* Desktop Navbar */}
      <Navbar expand="lg" className="custom-navbar fixed-top d-none d-lg-flex">
        <Container>
          <Navbar.Brand href="#home">
            <img src={LogoHeader} alt="Logo" className="navbar-logo" />
          </Navbar.Brand>
          <Nav className="mx-auto">
            <Nav.Link href="#home" onClick={handleNavClick} className={isActive('home')}>Home</Nav.Link>
            <Nav.Link href="#about" onClick={handleNavClick} className={isActive('about')}>About Us</Nav.Link>
            <Nav.Link href="#technologies" onClick={handleNavClick} className={isActive('technologies')}>Technologies</Nav.Link>
            <Nav.Link href="#contact" onClick={handleNavClick} className={isActive('contact')}>Contact Us</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* Mobile Top Bar with Hamburger */}
      <div className="mobile-navbar d-lg-none fixed-top d-flex justify-content-between align-items-center px-3 py-2">
        <img src={LogoHeader} alt="Logo" className="navbar-logo" />
        <button className="hamburger-btn" onClick={() => setShowSidebar(true)}>
          &#9776;
        </button>
      </div>

      {/* Sidebar (Swiper Style) */}
      <div className={`mobile-sidebar ${showSidebar ? 'open' : ''}`}>
       <div className="d-flex justify-content-between align-items-center px-3 pt-3">
    <img
      src={LogoHeader}
      alt="Logo"
      className="navbarmobile-logo"
      style={{ height: '45px' }}
    />
    <button className="close-btn" onClick={() => setShowSidebar(false)}>
      &times;
    </button>
  </div>
        <Nav className="flex-column p-3">
          <Nav.Link href="#home" onClick={handleNavClick} className={isActive('home')}>Home</Nav.Link>
          <Nav.Link href="#about" onClick={handleNavClick} className={isActive('about')}>About Us</Nav.Link>
          <Nav.Link href="#technologies" onClick={handleNavClick} className={isActive('technologies')}>Technologies</Nav.Link>
          <Nav.Link href="#contact" onClick={handleNavClick} className={isActive('contact')}>Contact Us</Nav.Link>
        </Nav>
      </div>

      {/* Backdrop Overlay */}
      {showSidebar && <div className="sidebar-overlay" onClick={() => setShowSidebar(false)}></div>}
    </>
  );
}

export default WebHeader;

